import { useEffect } from "react"
import { useQuery } from "@apollo/react-hooks"
import { useRouter } from "next/router"
import HtmlParser from "react-html-parser"
import { SVOD_BLOCK_TYPE, metadata } from "lacinetek-common/src/metadata"
import { CATEGORY_SELECTION, CATEGORY_BANNER_BIG, imagesOfType } from "lacinetek-common/src/images"

import { useCountry } from "lib/country"
import { useTranslation } from "lib/i18n/translation"
import { FETCH_SVOD_CATEGORIES } from "lib/graphql"
import { useLanguages } from "lib/languages"
import Gtm from "lib/gtm"

import { BlockTitle } from "components/subscription/block-title"
import { FooterOffer } from "components/subscription/footer-offer"
import { OfferComponent } from "components/offers"
import SkeletonLink from "components/common/skeleton-link"
import Image from "components/common/image"

import OffersLacinetekIcon from "static/assets/icons/offers-lacinetek.svg"

const OurOffers = () => {
	const router = useRouter()
	const { c } = useTranslation("common")
	const { country: { isoCode } } = useCountry()
	const { current } = useLanguages()
	const url = router ? router.asPath : null
	const { data, loading, refetch } = useQuery(FETCH_SVOD_CATEGORIES, {
		variables: {
			query: `nos-offres-${isoCode}`
		}
	})

	useEffect(() => {
		refetch()
	}, [current])

	if (loading) {
		return (
			<div className="is-loading centered" />
		)
	}


	const offers = data.cms.categories.items[0]
	const bannerImg = imagesOfType(offers, CATEGORY_SELECTION)[0]

	return (
		<>
			<Gtm pageType="Page nos offres" pagePath={url} pageTitle={c("offers")} />
			{
				!!bannerImg
				&& <section className="focus full no-fx">
					<figure className="cover full">
						<picture>
							<Image
								src={bannerImg}
								alt={offers?.descriptionShort}
							/>
						</picture>
					</figure>
				</section>
			}
			<section className="red">
				<BlockTitle block={offers} className="main-title" />
				{
					offers.description
					&& HtmlParser(offers.description)
				}
				<nav className="offers blocks">
					{
						offers.children.items
							.filter(offer => metadata(offer, SVOD_BLOCK_TYPE) !== "offrir")
							.map((offer, index) => <OfferComponent key={`offer-${index}`} offer={offer} />)
					}
					<div className="item">
						<SkeletonLink href="/offer-lacinetek" >
							<a href="#" title="En savoir plus" className="item-content">
								<figure className="small">
									<OffersLacinetekIcon title={c("gift-icon")} />
								</figure>
								<div className="infos">
									<h3 className="title">{c("gift-icon")}</h3>
								</div>
							</a>
						</SkeletonLink>
					</div>
				</nav>
				<FooterOffer />
			</section>
		</>
	)
}

export default OurOffers
